import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Text, { TYPES as types, SIZES as sizes, TextWithIcon } from 'components/elements/Text'
import './index.scss'
import { NavLink } from 'react-router-dom'
import IconNew from 'components/elements/iconsSize'

const LinksGroup = ({
    title,
    links,
    sublink,
    iconName,
    iconDivClassName,
    closeNavBar,
    isOpenGroup,
}) => {
    const [isOpen, setIsOpen] = useState(isOpenGroup)

    useEffect(() => {
        if(isOpenGroup) {
            setIsOpen(isOpenGroup)
        }
    }, [isOpenGroup])

    return (
        <div
            className='w-full flex flex-col justify-center items-center my-4'
        >
            <TextWithIcon
                inner={ title }
                type={types.medium150}
                generalStyles={{ cursor: 'pointer' }}
                size={sizes.medium}
                onClick={() => { setIsOpen(!isOpen) }}
                iconProps={{
                    style: { transform: `rotate(${!isOpen ? 180 : 0}deg)`, transition: '0.3s easy' }
                }}
                iconName="ResoucresDropDown"
                isIconRight={true}
                className="cursor-pointer"
                classNameActive='links_group_title'
            />
            {
                isOpen && (
                    <div
                        className='links_dropdown_list relative w-full flex flex-col mt-4 py-3 gap-[24px]'
                    >
                        {
                            Boolean(iconName) && (
                                <div className={ iconDivClassName }>
                                    <IconNew name={ iconName } />
                                </div>
                            )
                        }
                        {
                            links.map(link => (
                                link.isOutside ? (
                                    <div
                                        className='w-full flex items-center justify-center'
                                        onClick={() => {
                                            window.open(link.link, '_blank')
                                        }}
                                    >
                                        <Text
                                            inner={ link.label }
                                            type={types.medium150}
                                            size={sizes.medium}
                                            className="cursor-pointer justify-center"
                                        />
                                    </div>
                                ) : (
                                    <NavLink 
                                    to={ Boolean(sublink) ? `/${ sublink }/${ link.link }` : `/${link.link}` }
                                    key={link.label}
                                    onClick={() => closeNavBar()}
                                >
                                    <Text
                                        inner={ link.label }
                                        type={types.medium150}
                                        size={sizes.medium}
                                        className="cursor-pointer justify-center"
                                    />
                                </NavLink>
                                )
                            ))
                        }
                    </div>
                )
            }
        </div>
    )
}

LinksGroup.propTypes = {
    title: PropTypes.string,
    sublink: PropTypes.string,
    links: PropTypes.array,
    closeNavBar: PropTypes.func,
    isOpenGroup: PropTypes.bool
}

export default LinksGroup